import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiWave } from "@/generated/models/ApiWave";
import { WaveSmallLeaderboardItemOutcomes } from "../small-leaderboard/WaveSmallLeaderboardItemOutcomes";
import { SingleWaveDropAuthor } from "./SingleWaveDropAuthor";
import WaveDropTime from "../drops/time/WaveDropTime";
interface SingleWaveDropInfoAuthorSectionProps {
  readonly drop: ExtendedDrop | undefined;
  readonly wave: ApiWave | null;
}
export const SingleWaveDropInfoAuthorSection: React.FC<SingleWaveDropInfoAuthorSectionProps> = t0 => {
  const $ = _c(16);
  const {
    drop,
    wave
  } = t0;
  let t1;
  if ($[0] !== drop) {
    t1 = drop && <SingleWaveDropAuthor drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-w-[3px] tw-h-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== drop) {
    t3 = drop && <WaveDropTime timestamp={drop.created_at} />;
    $[3] = drop;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="tw-flex tw-gap-x-2 tw-items-center">{t2}{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-gap-x-2">{t1}{t4}</div>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== drop || $[11] !== wave) {
    t6 = wave && drop && <WaveSmallLeaderboardItemOutcomes drop={drop} wave={wave} />;
    $[10] = drop;
    $[11] = wave;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-flex-wrap tw-gap-y-2 tw-gap-x-4 tw-justify-between">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};